import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JsonParseSafeService {
  public safeParse<T>(value: string | null, defaultValue: T): T {
    try {
      if (!value) return defaultValue;
      // ignore SSR stub
      if (value === 'server') return defaultValue;
      return JSON.parse(value);
    } catch {
      return defaultValue;
    }
  }
}
